export { getFaqsForProjectByLocation, getProjectSlugFromFaq, useProjectFaqs } from './FaqService'
export { contentfulFaqLocations } from './contentfulFaqLocations'
export type { Faq } from '@/types/codegen-contentful'
